var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ehUsuarioFornecedor && _vm.canAccessDashFornecedor)?_c('dashboard-fornecedor'):_c('dashboard-funcionario-varejo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }